module.exports = __webpack_public_path__ + "img/avatar-46.c3b7ac14.png";